import { render, staticRenderFns } from "./ContentInfo.vue?vue&type=template&id=76a0170f&scoped=true"
import script from "./ContentInfo.vue?vue&type=script&lang=js"
export * from "./ContentInfo.vue?vue&type=script&lang=js"
import style0 from "./ContentInfo.vue?vue&type=style&index=0&id=76a0170f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a0170f",
  null
  
)

export default component.exports